import _ from 'lodash';
const NAME_SEPARATOR = '.';
const extractSuffixFromName = (name) => {
    let suffix = name;
    if (suffix.includes(NAME_SEPARATOR)) {
        const nameParts = name.split(NAME_SEPARATOR);
        suffix = nameParts[nameParts.length - 1];
    }
    return suffix;
};
export function createComponentDefinition(name, entry) {
    return { [name]: entry };
}
export function createComponentBuilder(name, entry) {
    const suffix = extractSuffixFromName(name);
    const newEntry = Object.assign({}, entry);
    return {
        withNickName(customNickName) {
            newEntry.nickname = customNickName || _.camelCase(suffix);
            return this;
        },
        withDataTypes(customDataTypes) {
            newEntry.dataTypes = customDataTypes || [`${suffix}Data`];
            return this;
        },
        withPropertyType(customPropertyType) {
            newEntry.propertyType = customPropertyType || `${suffix}Properties`;
            return this;
        },
        withStyles(customStyles) {
            newEntry.styles = customStyles || {
                [`${_.camelCase(suffix)}1`]: 'wixui.skins.Skinless',
            };
            return this;
        },
        setStylable(customStylableComp) {
            newEntry.isStylableComp = _.isNil(customStylableComp)
                ? true
                : customStylableComp;
            return this;
        },
        build() {
            return {
                [name]: Object.assign({}, newEntry),
            };
        },
    };
}
//# sourceMappingURL=createComponentDefinition.js.map